export const COLUMNS_DATA = ["name", "description"];
